import React from "react";
import { StringHelper } from "../../common/Helpers";
import { ConfirmDialog } from "./ConfirmDialog";

const HighlightedText = ({ text }) => {
  const source = text === undefined || text === null ? "" : String(text);
  return (
    <>
      {[...source].map((ch, index) =>
        ch.charCodeAt(0) > 127 ? (
          <span
            key={index}
            style={{ backgroundColor: "#ffeb3b", fontWeight: "bold" }}
          >
            {ch}
          </span>
        ) : (
          <React.Fragment key={index}>{ch}</React.Fragment>
        )
      )}
    </>
  );
};

export const NonAsciiConfirmationMessage = ({ fields }) => {
  const invalidFields = (fields || []).filter(
    (field) => StringHelper.findNonAsciiChars(field.value).length > 0
  );

  if (invalidFields.length === 0) {
    return null;
  }

  return (
    <>
      <div>There are invalid characters in</div>
      <br />
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <tbody>
          {invalidFields.map((field) => (
            <tr key={field.label}>
              <td
                style={{
                  padding: "8px 16px 8px 0",
                  verticalAlign: "top",
                  whiteSpace: "nowrap",
                }}
              >
                <strong>{field.label || "This field"}:</strong>
              </td>
              <td style={{ padding: "8px 0", verticalAlign: "top" }}>
                <HighlightedText text={field.value} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <em style={{ fontSize: "0.875em" }}>
        The invalid characters may cause <strong>unexpected results</strong>
        <br />
        in the ticket prints.
        <br />
        We would like to suggest to replace them by
        <br />
        <strong>
          keying in the same character manually before proceeding.
        </strong>
      </em>
    </>
  );
};

export const NonAsciiConfirmDialog = ({
  visible,
  fields,
  onProceed,
  onCancel,
}) => (
  <ConfirmDialog
    visible={visible}
    title="Invalid Characters"
    onProceed={onProceed}
    onCancel={onCancel}
  >
    <NonAsciiConfirmationMessage fields={fields} />
  </ConfirmDialog>
);
